import type { AIChatDisabledOrgAttemptSource } from 'types/graphql'

import { CitizenAIChatMessage } from 'src/components/CitizenAIAssistant/CitizenAIAssistantContext'

export type { AIChatDisabledOrgAttemptSource }

export const DisabledOrgAttemptSource = {
  RouteNavigation: 'RouteNavigation',
  JurisdictionSearch: 'JurisdictionSearch',
} as const satisfies Record<string, AIChatDisabledOrgAttemptSource>

export const buildDisabledOrgMessage = (orgName: string): CitizenAIChatMessage => ({
  id: `system-disabled-${orgName}-${Date.now()}`,
  text: `<div>${orgName} hasn't enabled this AI assistant feature yet. I can still help you with general questions about permits, codes, and government processes. For questions specific to ${orgName}, I'd recommend reaching out to their offices directly.</div>`,
  sender: 'ai',
})
